import { getHost } from '../api/utils'
import { handleLastError } from '../services/extServices'
import { PlaybookRecordingE } from '../types/backgroundAPI'
import { RecordingIframeAction } from '../services/parentService'

type Tab = chrome.tabs.Tab

export const sendMsgToTab = (
    tabId: number | undefined,
    msg: string,
    response?: any,
    callback?: (r: any) => void
) => {
    if (tabId && tabId >= 0) {
        chrome.tabs.sendMessage(
            tabId,
            {
                action: msg,
                response: response || {},
            },
            (response: any) => {
                if (chrome.runtime.lastError) {
                    handleLastError(chrome.runtime.lastError.message)
                    return
                }

                callback?.(response)
            }
        )
    }
}

export const sendMsgToFrame = (
    tabId: number,
    frameId,
    msg: string,
    response?: any
) => {
    if (tabId >= 0) {
        chrome.tabs.sendMessage(
            tabId,
            {
                action: msg,
                response: response || {},
            },
            { frameId },
            () => {
                if (chrome.runtime.lastError) {
                    handleLastError(chrome.runtime.lastError.message)
                }
            }
        )
    }
}

export const sendMsgToAllTabs = (msg: { action: string; response?: any }) => {
    chrome.tabs.query({}, tabs => {
        tabs.forEach(tab => {
            const tabId = tab?.id || -1
            sendMsgToTab(tabId, msg.action, msg.response)
        })
    })
}

export const openTabForLogin = () =>
    chrome.tabs.create({
        url: `${getHost()}/signup?src=extension&utm_source=ext_store&utm_medium=referral`,
        active: true,
    })

export const openMessageModal = (msg: RecordingIframeAction) => {
    // First establish connection with current tab
    chrome.tabs.query({ active: true, currentWindow: true }, tabs => {
        const currentTab = tabs[0]
        if (currentTab && currentTab.id) {
            sendMsgToTab(currentTab.id, msg)
        }
    })
}

export const openLibIframe = (tabId: number, params, callback) => {
    sendMsgToTab(tabId, 'RUN_LIB', params, callback)
}

export const openRecIframe = (tabId: number, params, callback = () => {}) => {
    sendMsgToTab(tabId, 'RUN_REC', params, callback)
}

export const getTabMetadata = (tabId: number) =>
    new Promise<Tab | undefined>(resolve => {
        if (tabId >= 0) {
            chrome.tabs.get(tabId, (tab: Tab) => {
                resolve(tab)
            })
        } else {
            resolve(undefined)
        }
    })

export const sendResponseAsMessage = (
    msg: any,
    sender: chrome.runtime.MessageSender,
    response: any
) => {
    const tabId = sender.tab?.id || -1

    if (tabId >= 0) {
        chrome.tabs.sendMessage(
            tabId,
            {
                action: msg.action,
                id: msg.id,
                response,
            },
            () => {
                if (chrome.runtime.lastError) {
                    handleLastError(chrome.runtime.lastError.message)
                }
            }
        )
    }
}

export const sendRecordingStatus = (response: { status: string }) => {
    sendMsgToAllTabs({
        action: PlaybookRecordingE.SUBSCRIBE_TO_REC_STATUS,
        response,
    })
}
